import type { DummyFoods } from './dummyFoods'

export const tortilla: DummyFoods = {
  Tortilla: {
    Corn: ['Corn tortilla'],
    Flour: ['Flour tortilla'],
  },
}
